import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Icon from '@ui/Icon';
import UserProfileBubble from 'components/UserProfileBubble/UserProfileBubble';
import Tooltip from 'components/Tooltip';
import { TeamMember } from '../../../../server/graphql/__generated.types';

interface OwnerBubbleProps {
  isWellSaidCreator: boolean;
  hasTeam: boolean;
  projectOwner?: Pick<TeamMember, 'id' | 'initials' | 'email'>;
  creatorId?: string;
}

const OwnerBubble = (props: OwnerBubbleProps) => {
  const { isWellSaidCreator, hasTeam, projectOwner, creatorId } = props;
  const { classes } = useStyles();

  if (isWellSaidCreator) {
    return (
      <Tooltip text="Wellsaid" placement="top">
        <div>
          <Icon
            type="logoMark"
            aria-label="wellsaid"
            className={classes.icon}
          />
        </div>
      </Tooltip>
    );
  }

  if (hasTeam && projectOwner) {
    return (
      <UserProfileBubble
        userId={projectOwner.id}
        userInitials={projectOwner.initials}
        tooltipText={projectOwner.email}
      />
    );
  }

  if (hasTeam && creatorId) {
    return (
      <UserProfileBubble userId={creatorId} tooltipText="Deactivated user" />
    );
  }

  return null;
};

const useStyles = makeStyles()(() => ({
  icon: {
    display: 'flex',
    height: '24px',
    width: '24px',
  },
}));

export default OwnerBubble;
